import { gql } from "@apollo/client";

const schema = {
  current: {
    name: "state",
    serviceName: "graphql",
    query: gql`
      query state($ids: [String]) {
        state(ids: $ids) {
          data {
            media {
              id
              name
              full_url
              size
              collection_name
            }
          }
        }
      }
    `,
  },
};

export default schema;
